import { SEOHead } from "@components/organisms";
import { InnerPageLayout } from "@components/templates";
import { useStaticPage } from "@shared/hooks";

interface StaticContentPageProps {
  slug: string;
  title: string;
}

/**
 * Generic static content page — loads HTML/text content from CMS by slug.
 * Used for: Términos y Condiciones (slug: "terminos")
 *           Protección de Datos Personales (slug: "privacidad")
 * GET /rest/api/web/cms/pages/{slug}
 */
export function StaticContentPage({ slug, title }: StaticContentPageProps) {
  const { data: page, isLoading, error } = useStaticPage(slug);

  return (
    <>
      <SEOHead title={page?.title ?? title} />
      <InnerPageLayout title={page?.title ?? title}>
        <div className="flex flex-col px-4 sm:px-8 pb-8" style={{ maxWidth: 760 }}>
          {isLoading && (
            <p className="text-primary-110" style={{ fontSize: 14 }}>
              Cargando...
            </p>
          )}
          {error && (
            <p className="text-red-500" style={{ fontSize: 14 }}>
              No se pudo cargar el contenido. Intenta nuevamente.
            </p>
          )}
          {page?.content && (
            <div
              className="text-black leading-relaxed"
              style={{ fontSize: 14 }}
              dangerouslySetInnerHTML={{ __html: page.content }}
            />
          )}
        </div>
      </InnerPageLayout>
    </>
  );
}
